export const demoCars: any[] = [
  {
    id: 'demo-1',
    name: 'BMW X5',
    model: 'M50i',
    year: 2021,
    plate: 'JK-1234',
    icon_type: 'image',
    image_url: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?auto=format&fit=crop&q=80&w=400',
    color: '#3b82f6',
    is_favorite: true,
    user_id: 'demo-user',
    slug: 'bmw-x5'
  },
  {
    id: 'demo-2',
    name: 'Audi A6',
    model: 'Avant',
    year: 2019,
    plate: 'LV-5678',
    icon_type: 'emoji',
    emoji: '🏎️',
    color: '#ef4444',
    is_shared: true,
    user_id: 'other-user',
    slug: 'audi-a6'
  },
  {
    id: 'demo-3',
    name: 'Toyota RAV4',
    model: 'Hybrid',
    year: 2022,
    plate: 'TX-9999',
    icon_type: 'icon',
    icon_name: 'Car',
    color: '#10b981',
    user_id: 'demo-user',
    slug: 'toyota-rav4'
  },
  {
    id: 'demo-4',
    name: 'VW Golf',
    model: 'MK7',
    year: 2015,
    plate: 'GL-4321',
    icon_type: 'emoji',
    emoji: '📦',
    color: '#6b7280',
    is_archived: true,
    user_id: 'demo-user',
    slug: 'vw-golf'
  }
];

export const demoLogEntries: any[] = [
  {
    id: 'entry-1',
    date: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    mileage: 45200,
    title: 'Full Service',
    expenses: [
      { type: 'maintenance', amount: 450, description: 'Oil, filters, spark plugs' },
      { type: 'repairs', amount: 120, description: 'Brake pads replacement' }
    ],
    car_id: 'demo-1'
  },
  {
    id: 'entry-2',
    date: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(),
    mileage: 44100,
    title: 'Fuel up',
    expenses: [
      { type: 'fuel', amount: 85, description: '62L @ 1.37/L', fuel_liters: 62 }
    ],
    car_id: 'demo-1'
  },
  {
    id: 'entry-3',
    date: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString(),
    mileage: 43200,
    title: 'Insurance',
    expenses: [
      { type: 'insurance', amount: 1200, description: 'Full KASKO' }
    ],
    car_id: 'demo-1'
  },
  {
    id: 'entry-4',
    date: new Date(Date.now() - 70 * 24 * 60 * 60 * 1000).toISOString(),
    mileage: 42100,
    title: 'Fuel up',
    expenses: [
      { type: 'fuel', amount: 92, description: '65L @ 1.41/L', fuel_liters: 65 }
    ],
    car_id: 'demo-1'
  },
  {
    id: 'entry-5',
    date: new Date(Date.now() - 100 * 24 * 60 * 60 * 1000).toISOString(),
    mileage: 41000,
    title: 'New Tires',
    expenses: [
      { type: 'parts', amount: 800, description: 'Michelin Pilot Sport 5' }
    ],
    car_id: 'demo-1'
  },
  {
    id: 'entry-6',
    date: new Date(Date.now() - 150 * 24 * 60 * 60 * 1000).toISOString(),
    mileage: 38000,
    title: 'Annual Tax',
    expenses: [
      { type: 'taxes', amount: 160, description: 'Annual road tax' }
    ],
    car_id: 'demo-1'
  }
];
